import { render, staticRenderFns } from "./RedimensionamentoHospitalarDownload.vue?vue&type=template&id=8e6f8e76&scoped=true"
import script from "./RedimensionamentoHospitalarDownload.vue?vue&type=script&lang=js"
export * from "./RedimensionamentoHospitalarDownload.vue?vue&type=script&lang=js"
import style0 from "./RedimensionamentoHospitalarDownload.vue?vue&type=style&index=0&id=8e6f8e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6f8e76",
  null
  
)

export default component.exports